import { useEffect, useMemo, useRef } from 'react'
import { QRCodeCanvas } from 'qrcode.react'
import { ButtonOutline } from '../../../../Components/Screen/Button/button'

function generateHash() {
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    const bytes = new Uint8Array(16)
    window.crypto.getRandomValues(bytes)
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
  }
  return Math.random().toString(16).slice(2).padEnd(32, '0')
}

export function QRCodeBlock({ filename = 'qrcode' }) {
  const containerRef = useRef(null)

  const hash = useMemo(generateHash, [])

  const url = useMemo(() => {
    if (typeof window === 'undefined') return ''
    const u = new URL(window.location.href)
    u.searchParams.set('h', hash)
    return u.toString()
  }, [hash])

  useEffect(() => {
    if (typeof window === 'undefined') return
    const u = new URL(window.location.href)
    if (u.searchParams.get('h') !== hash) {
      u.searchParams.set('h', hash)
      window.history.replaceState(null, '', u.toString())
    }
  }, [hash])

  const handleDownload = () => {
    const canvas = containerRef.current?.querySelector('canvas')
    if (!canvas) return
    const link = document.createElement('a')
    link.href = canvas.toDataURL('image/png')
    link.download = `${filename}.png`
    link.click()
  }

  return (
    <div className="flex flex-col items-center gap-4">
      <div ref={containerRef} className="bg-white p-3 rounded-md">
        <QRCodeCanvas value={url} size={200} level="M" includeMargin={false} />
      </div>
      <ButtonOutline onClick={handleDownload}>Download QRCode</ButtonOutline>
    </div>
  )
}
